import styled from 'styled-components';

export const Container = styled.div`
  padding: 0 40px;

  @media (max-width: 743px) {
    padding: 0 15px;
  }
`;
